import { useEffect, useState } from "react";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult() {
  const cancelled = window.location.pathname.startsWith("/payment/cancel");
  const sid = new URLSearchParams(window.location.search).get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");

  useEffect(() => {
    if (cancelled || !sid) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          localStorage.setItem("pro_session_id", sid);
          return setState("paid");
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch { /* keep polling */ }
      if (++tries < 15) setTimeout(poll, 2000); else setState("failed");
    };
    poll();
  }, [cancelled, sid]);

  const home = () => { window.location.href = "/"; };
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="payment-result">
      <div className="card p-8 max-w-sm w-full text-center">
        {state === "checking" && <><Loader2 className="w-10 h-10 mx-auto animate-spin text-[#22D3EE]" /><p className="mt-4">Confirming your payment…</p></>}
        {state === "paid" && <><CheckCircle2 className="w-12 h-12 mx-auto text-[#34D399]" /><h1 className="font-head font-bold text-2xl mt-4" data-testid="payment-success">Membership active!</h1>
          <p className="text-sm text-slate-400 mt-2">Your new plan is unlocked on your account.</p></>}
        {state === "failed" && <><XCircle className="w-12 h-12 mx-auto text-[#F87171]" /><h1 className="font-head font-bold text-xl mt-4" data-testid="payment-failed">Payment not confirmed</h1>
          <p className="text-sm text-slate-400 mt-2">No charge was confirmed. You can try again.</p></>}
        {state === "cancelled" && <><XCircle className="w-12 h-12 mx-auto text-slate-400" /><h1 className="font-head font-bold text-xl mt-4" data-testid="payment-cancelled">Checkout cancelled</h1>
          <p className="text-sm text-slate-400 mt-2">You weren't charged.</p></>}
        {state !== "checking" && <button onClick={home} className="mt-6 px-6 py-3 rounded-full bg-[#22D3EE] text-[#03141A] font-semibold w-full" data-testid="payment-home-btn">Back to the app</button>}
      </div>
    </div>
  );
}
